import Services from '../../service/ApiServices'
import _ from 'lodash'

export const GET_ALL_WAITLISTS = "WAITLIST/GET_ALL_WAITLISTS"
export const GET_ALL_WAITLIST_STATUSES = "WAITLIST/GET_ALL_WAITLIST_STATUSES"
export const GET_WAITLIST_CLIENTS = "WAITLIST/GET_WAITLIST_CLIENTS"
export const SET_FILTER = "WAITLIST/SET_FILTER"
export const RESET_FILTER = "WAITLIST/RESET_FILTER"
export const SELECTED_WAITLIST = "WAITLIST/SELECTED_WAITLIST"
export const ADD_CLIENT_WAITLIST = "WAITLIST/ADD_CLIENT_WAITLIST"
export const EDIT_CLIENT_WAITLIST = "WAITLIST/EDIT_CLIENT_WAITLIST"
export const SEARCH_WAITLIST_CLIENT = "WAITLIST/SEARCH_WAITLIST_CLIENT";
export const REMOVE_CLIENT_WAITLIST = "WAITLIST/REMOVE_CLIENT_WAITLIST"

export const GetAllWaitlists = async ()=>{
    const waitlists = (await Services.Waitlist.getAllWaitlists()).data;   
    return {type:GET_ALL_WAITLISTS, allWaitlist:waitlists}
}

export const GetAllWaitlistStatuses = async()=>{
    const statuses = (await Services.Waitlist.getAllWaitlistStatuses()).data;
    return {type:GET_ALL_WAITLIST_STATUSES, statuses}
}

export const GetClientsByWaitlistId = async (key, value)=>{
    const clients = _.gt(key, 0)?(await Services.Waitlist.getWaitlistClients({waitListId:key, searchValue:value})).data :[]  
    return {type:GET_WAITLIST_CLIENTS, waitlistClients:_.isEmpty(clients)?[] :clients.clientWaitlistStatus}
}
export const SetFilter = (data)=>{
    return {type: SET_FILTER, filter:data}
}

export const ResetFilter = ()=>{
    return {type: RESET_FILTER}
}

export const SetSelectedWaitlist = (selectedWaitlist)=>{
    return {type:SELECTED_WAITLIST, selectedWaitlist}
}

export const AddClientWaitlist = async (data)=>{
    await Services.Waitlist.addClientToWaitlist(data)
    return {type:ADD_CLIENT_WAITLIST, data}
}


export const EditClientWaitlist = async (data)=>{
    await Services.Waitlist.editWaitlistClient(data)
    return {type:EDIT_CLIENT_WAITLIST, data}
}

export const SetSearchValue = (searchValue)=>{  
    return {type:SEARCH_WAITLIST_CLIENT, searchValue}
}

export const RemoveClientWaitlist = async(waitlistAssignmentId)=>{
    await Services.Waitlist.removeWaitlistClient(waitlistAssignmentId)
    return {type:REMOVE_CLIENT_WAITLIST, waitlistAssignmentId}

}